import { getApi } from "./api_instance";

export const getAllRegistries = async (logout) => {
  try {
    return await getApi({
      apiUrl: "/admin/projects/api/registry/getAllRegistires",
      logout,
    });
  } catch (error) {
    throw error;
  }
};
